import { bootstrapApplication } from '@angular/platform-browser';
import { configureStaffAuth, isRedirectBridgeRequest, runRedirectBridge } from '@raptor-fe/services';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

configureStaffAuth(environment.staffSignInEnabled ? environment.entra : null);

if (isRedirectBridgeRequest()) {
    void runRedirectBridge();
} else {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}
